import { Component } from '@angular/core';
import { TransferEnrollmentTrendsFormComponent } from '../transfer-enrollment-trends-form/transfer-enrollment-trends-form.component';
import { ToolListService } from '@/shared/services/tool-list.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-transfer-enrollment-trends-page',
  templateUrl: './transfer-enrollment-trends-page.component.html',
  styleUrl: './transfer-enrollment-trends-page.component.css',
  standalone: false,
})
export class TransferEnrollmentTrendsPageComponent {
  constructor(
    public dialog: MatDialog,
    public toolListService: ToolListService,
  ) {}

  // open pop up dialog when in mobile mode if filter is clicked
  openDialog() {
    this.dialog.open(TransferEnrollmentTrendsFormComponent);
  }
}
